import { render, staticRenderFns } from "./vessels-reports.vue?vue&type=template&id=10d8c1d2&scoped=true"
import script from "./vessels-reports.vue?vue&type=script&lang=js"
export * from "./vessels-reports.vue?vue&type=script&lang=js"
import style0 from "./vessels-reports.vue?vue&type=style&index=0&id=10d8c1d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d8c1d2",
  null
  
)

export default component.exports